import Axios from 'axios'
import getTokens from 'utilities/getTokens'
import { POLICY_CAMPAIGNS } from './reducers'

/**
 * Fetches policy campaigns
 */
export const getPolicyCampaigns = () => {
  const token = getTokens()

  return async (dispatch) => {
    dispatch({ type: POLICY_CAMPAIGNS.LOADING })
    const res = await Axios({
      url: '/policy/campaign',
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
    }).then((res) => {
      dispatch({ type: POLICY_CAMPAIGNS.LOADED })
      dispatch({ type: POLICY_CAMPAIGNS.FETCHED, payload: res.data })
    })
    return res
  }
}

/**
 * Create a policy campaign
 * @param {Object} campaignData Campaign Object containing
 * @param {Function} callback Callback function. Recieves res/err object and err status
 */
export const createPolicyCampaign = (campaignData, callback) => {
  const token = getTokens()
  const url = new URL(campaignData.websiteUrl)
  const websiteUrl = url.host
  // const protocol = url.protocol.replace(/:$/, '')
  const protocol = url.protocol

  return async (dispatch) => {
    dispatch({ type: POLICY_CAMPAIGNS.LOADING })
    const res = await Axios({
      url: '/policy/campaign',
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      data: {
        campaign: {
          ...campaignData,
          websiteUrl,
          protocol,
          legislation: {
            gdpr: 'EU Only',
            ccpa: false,
            lgpd: false,
          },
        },
      },
    })
      .then((res) => {
        if  (Object.keys(res.data).includes('err') && res.data.err)  {
          dispatch({
            type: 'FIRE_TOASTER',
            payload: { type: 'error', message: res.data.message },
          })
          if (callback) callback(res.data, true)
          dispatch({ type: POLICY_CAMPAIGNS.ERROR, payload: res.data })
        }  else  {
          dispatch({ type: POLICY_CAMPAIGNS.CREATED, payload: res.data.data })
          dispatch({ type: POLICY_CAMPAIGNS.SAVE_OPENED_CAMPAIGN, payload: res.data.data })
          dispatch({
            type: 'FIRE_TOASTER',
            payload: { type: 'success', message: 'Camapaign Created' },
          })
          if (callback) callback(res.data.data, false)
        }
        // dispatch({ type: POLICY_CAMPAIGNS.LOADED })
      })
      .catch((err) => {
        console.log('err------',err)
        if (callback) callback(err, true)
        dispatch({ type: POLICY_CAMPAIGNS.ERROR, payload: err })
        dispatch({
          type: 'FIRE_TOASTER',
          payload: { type: 'error', message: 'Some error occured' },
        })
      })
    return res
  }
}

/**
 * Updated the campaign object
 * @param {String} campaignId Campaign ID
 * @param {Object} updatingData Data which needs to be updated
 * @param {Function} [callback] this funtion will run after the network call completes. Recieves the `response` and `errorStatus` as arguments.
 * @param {Boolean} [disableLoading] Disables the loading state of the redix store variable of this object.
 */
export const updatePolicyCampaign = (campaignId, updatingData, callback, disableLoading=false) => {
  const token = getTokens()
  return async (dispatch) => {
    if (disableLoading === false) dispatch({ type: POLICY_CAMPAIGNS.LOADING })
    const res = await Axios({
      url: `/policy/campaign/${campaignId}`,
      method: 'PUT',
      headers: { Authorization: `Bearer ${token}` },
      data: {
        campaign: {
          ...updatingData,
        },
      },
    })
      .then((res) => {
        // dispatch({ type: POLICY_CAMPAIGNS.LOADED })
        if (callback) callback(res.data, false, campaignId)
        dispatch({ type: POLICY_CAMPAIGNS.UPDATED, payload: res.data })
        dispatch({
          type: 'FIRE_TOASTER',
          payload: { type: 'success', message: 'Camapign Updated' },
        })
      })
      .catch((err) => {
        if (callback) callback(err, true, campaignId)

        dispatch({
          type: 'FIRE_TOASTER',
          payload: { type: 'error', message: 'Some Error Occurred' },
        })
        dispatch({ type: POLICY_CAMPAIGNS.ERROR })
      })
    return res
  }
}

/**
 * Delete a campaign
 * @param {Object} campaignData Campaign object
 * @param {Funtion} callback callback funtion. Recieves res/err object and err status
 */
export const deletePolicyCampaign = (campaignData, callback) => {
  const token = getTokens()
  return async (dispatch) => {
    // dispatch({ type: POLICY_CAMPAIGNS.LOADING })
    const res = await Axios({
      url: `/policy/campaign/${campaignData._id}`,
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        // dispatch({ type: POLICY_CAMPAIGNS.LOADED })
        dispatch({ type: POLICY_CAMPAIGNS.DELETED, payload: res.data })
        dispatch({
          type: 'FIRE_TOASTER',
          payload: { type: 'success', message: 'Camapign Deleted' },
        })

        if (callback) callback(res.data, false)
      })
      .catch((err) => {
        if (callback) callback(err, true)
        dispatch({ type: POLICY_CAMPAIGNS.ERROR, payload: err })
        dispatch({
          type: 'FIRE_TOASTER',
          payload: { type: 'error', message: 'Some Error Occured' },
        })
      })
    return res
  }
}
